// extracted by mini-css-extract-plugin
export default {"expandBtn":"CoverageDocumentTabs_expandBtn__HZ6WC","flex":"CoverageDocumentTabs_flex__-ThA-","tabs":"CoverageDocumentTabs_tabs__3Aq5d"};